// extracted by mini-css-extract-plugin
module.exports = {"_cta-style":"CtaStyle__cta-style_3Hcs8 relative fw7 ttu tc white _collision fill-green"};